import { type RefObject } from 'react';
import { Trans, useTranslation } from 'next-i18next/pages';
import { Checkbox } from '@pkgs/components/components/Checkbox/Checkbox';
import { type Listing, CountryCode } from '@pkgs/api';

import { TRANSLATION_NAMESPACE } from '@/i18n/config';
import { useSettings } from '@/hooks/useSettings';
import { useExposeTracking } from '@/hooks/useExposeTracking';
import { ExpandableLabel } from '@/components/property-expose/ExpandableLabel/ExpandableLabel';

import styles from '../ContactForm.module.css';

export const FinanceConsent = ({ financeConsentRef, listing }: { financeConsentRef: RefObject<HTMLDivElement>; listing: Listing }) => {
  const { t } = useTranslation(TRANSLATION_NAMESPACE.property_expose);
  const { trackExposeUserInteractionEvent } = useExposeTracking();
  const { countryCode, language } = useSettings();

  return (
    <Checkbox
      className={styles.checkbox}
      name="financeConsent"
      aria-label={t('search.contact.form.label.financeConsent.checkboxLabel')}
      size="s"
      onChange={() => trackExposeUserInteractionEvent({ elementId: 'request-expose_consent_checkbox-finance' })}
      label={
        <>
          <ExpandableLabel
            className={styles.expandableMarketingConsent}
            maxLines={3}
            data-testid="expose-contact-form_finance-consent_expandable-label"
          >
            <div ref={financeConsentRef}>
              <Trans
                i18nKey={
                  listing.countryAlpha2 === CountryCode.DE
                    ? 'search.contact.form.label.financeConsentDE'
                    : 'search.contact.form.label.financeConsent'
                }
                t={t}
                values={{ legalEntity: listing.financeConsent?.legalEntity }}
                components={[
                  <a key="office-name" href={listing.financeConsent?.imprintUrl} target="_blank" rel="noreferrer" />,
                  <a key="shopfinder-link" href={`/${countryCode.toLowerCase()}/${language}/shops`} target="_blank" rel="noreferrer" />,
                  <a key="privacy-link" href={listing.financeConsent?.dataPrivacyUrl} target="_blank" rel="noreferrer" />,
                ]}
              />
            </div>
          </ExpandableLabel>
        </>
      }
    />
  );
};
